import { cx } from "@emotion/css";
import { generatePath, Link } from "react-router-dom";
import routing from "routing";
import type { FaqContent } from "src/api/faq";

interface GuideContentsLinkProps {
	section: FaqContent;
	index: number;
	isSelected: boolean;
	onSelect?: () => void;
}

export const GuideContentsLink = ({
	section,
	index,
	isSelected,
	onSelect,
}: GuideContentsLinkProps) => (
	<Link
		to={generatePath(routing.paths.guide, { sectionId: section.id })}
		className={cx("contents-item", { "contents-item--selected": isSelected })}
		onClick={onSelect}
		data-test-id="guide-contents-link"
	>
		{index + 1}. {section.name}
	</Link>
);
